export const GET_ASSIGNMENT_REQUEST = "GET_ASSIGNMENT_REQUEST";
export const GET_ASSIGNMENT_SUCCESS = "GET_ASSIGNMENT_SUCCESS";
export const GET_ASSIGNMENT_ERROR = "GET_ASSIGNMENT_ERROR";
export const GET_ASSIGNMENT_DETAIL = "GET_ASSIGNMENT_DETAIL";
export const GET_ASSIGNMENT_BY_ID = "GET_ASSIGNMENT_BY_ID";
export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";
export const SET_ASSIGNMENT_GRID_TYPE = "SET_ASSIGNMENT_GRID_TYPE";
